import React from 'react'
import { ArrowUpRightFromSquare, cn, Paragraph, PlusIcon } from '@quickmd-llc/design-system'
import { fulfilmentLine, type VisitPrescription } from './prescriptionFulfilment'

export type PrescriptionTileData = Pick<VisitPrescription, 'IsHomeDelivery' | 'Pharmacy' | 'Status'> & {
  DrugName?: string | null
  EncounterUrl?: string | null
}

type Props = {
  prescription: PrescriptionTileData
  handleClick: (prescription: PrescriptionTileData) => void
  isSuggested?: boolean
}

export const PrescriptionTile: React.FC<Props> = ({ prescription, handleClick, isSuggested }) => {
  const name = prescription.DrugName ?? ''
  const encounterUrl = prescription.EncounterUrl || ''
  // QMD-4913: where the script was sent. Nothing when the backend does not report `IsHomeDelivery`,
  // or once the script is no longer live.
  const fulfilment = fulfilmentLine(prescription)

  return (
    <div
      role='presentation'
      className={cn(
        'pointer-events-none flex w-full items-center justify-between gap-sp-1 rounded-lg border border-border-dark bg-white px-sp-2 py-sp-1.5',
        isSuggested && 'border-border-medium bg-surface-active',
        (encounterUrl || isSuggested) && 'pointer-events-auto cursor-pointer hover:bg-coastal-blue-10',
      )}
      onClick={() => handleClick(prescription)}>
      <div className='flex min-w-0 flex-1 flex-col'>
        <Paragraph className='flex-wrap text-text-dark'>{name}</Paragraph>
        {fulfilment ?
          // Wraps rather than truncates: in the warning case the pharmacy name is the part that matters.
          <Paragraph size='sm' className='break-words text-text-medium'>
            {fulfilment}
          </Paragraph>
        : null}
      </div>
      {(encounterUrl || isSuggested) && isSuggested ?
        <PlusIcon size='sm' className='text-text-highlight' />
      : <ArrowUpRightFromSquare size='sm' className='text-text-highlight' />}
    </div>
  )
}
